module.exports = __webpack_public_path__ + "img/alert.65b28532.svg";